<template>
  <v-card outlined max-width="380" class="mb-5">
    <v-card-subtitle>
      <div v-if="order.status == 'writing'">
        <OrderDeliverBtn :order="order" />

        <v-btn color="error" class="mt-3" small depressed @click="cancelOrder">
          <span class="font-weight-bold">執筆をキャンセルする</span>
        </v-btn>
      </div>
      <div v-else-if="order.status == 'under_inspection'">
        現在、検収作業を行っております。<br />
        今しばらくお待ちください。
      </div>
      <div v-else-if="writerCompleted(order.status)">検収が完了しました。</div>
    </v-card-subtitle>
    <v-divider />
    <v-card-text class="py-0">
      <WritingProgress
        :order-status="order.status"
        :order-is-master="order.isMaster"
      />
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-row class="px-5 mb-2">
        <template v-if="mode === 'edit'">
          <PostPreviewBtn :post-id="post.id" :mode="mode" />
          <PostSaveBtn :order-id="order.id" :post="post" />
        </template>
        <PostStatus :post="post" />
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import WritingProgress from './WritingProgress'
import PostPreviewBtn from '@/components/postEditor/parts/PostPreviewBtn'
import PostSaveBtn from '@/components/postEditor/parts/PostSaveBtn'
import PostStatus from '@/components/postEditor/parts/PostStatus'
import order_utils from '@/mixins/order_utils'
import OrderDeliverBtn from '@/components/postEditor/parts/OrderDeliverBtn'

export default {
  components: {
    WritingProgress,
    PostPreviewBtn,
    PostSaveBtn,
    PostStatus,
    OrderDeliverBtn
  },
  mixins: [order_utils],
  data () {
    return {
      displayInstruction: false
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      order: (state) => state.PostEditor.post.recentOrder,
      mode: (state) => state.PostEditor.mode
    })
  },
  methods: {
    deliverOrder () {
      this.$store.dispatch('PostEditor/deliverOrder', this.order.id)
    },

    cancelOrder () {
      if (
        window.confirm(
          '執筆のキャンセルを行うと、執筆中の記事の内容が消去され、以後この記事の執筆ができなくなります。\n 本当にキャンセルしますか？'
        )
      ) {
        this.$store.dispatch('PostEditor/cancelOrder', this.order.id)
      }
    }
  }
}
</script>
